import {
  getAdvertisersEpisodeLevelMetrics,
  AdvertisersEpisodeLevelWidgetResponse,
  GetAdvertisersEpisodeLevelMetricsArgs,
} from 'api/services';
import { UseQueryOptions, useQuery } from 'react-query';
import { ParsedAdvertisersEpisodeStatsData } from '../types';
import { promoMetricsQueries } from './queryKeys';
import { promoEpisodeLevelDataSelector } from './selectors';

type QueryKey = ReturnType<typeof promoMetricsQueries.episodeLevel>;

function useAdvertisersEpisodeLevelWidgetMetrics<TData = unknown>(
  args: GetAdvertisersEpisodeLevelMetricsArgs,
  opts?: Omit<
    UseQueryOptions<
      AdvertisersEpisodeLevelWidgetResponse,
      unknown,
      TData,
      QueryKey
    >,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery<
    AdvertisersEpisodeLevelWidgetResponse,
    unknown,
    TData,
    QueryKey
  >(
    promoMetricsQueries.episodeLevel(args),
    () => getAdvertisersEpisodeLevelMetrics(args),
    opts,
  );
}

export function usePromoEpisodeLevelMetrics(
  args: GetAdvertisersEpisodeLevelMetricsArgs,
  opts?: Omit<
    UseQueryOptions<
      AdvertisersEpisodeLevelWidgetResponse,
      unknown,
      ParsedAdvertisersEpisodeStatsData[],
      QueryKey
    >,
    'queryKey' | 'queryFn'
  >,
) {
  return useAdvertisersEpisodeLevelWidgetMetrics(args, {
    select: promoEpisodeLevelDataSelector,
    ...opts,
  });
}
